import React from 'react';

/**
 * Render text containing [^n] citation markers as React nodes with
 * clickable superscript chips that link to the matching citation URL.
 *
 * @param {string} text  body text containing [^n] tokens (n = 1..N)
 * @param {Array}  citations  list of {n, url, title, publication}
 * @param {object} opts  { testIdPrefix?: string }
 */
export function renderInlineCitations(text, citations, opts = {}) {
  if (!text) return null;
  const prefix = opts.testIdPrefix || 'inline-cite';
  const tokens = text.split(/(\[\^\d+\])/g);
  return tokens.map((tok, idx) => {
    const m = /\[\^(\d+)\]/.exec(tok);
    if (m) {
      const n = parseInt(m[1], 10);
      const c = citations?.find((x) => x.n === n);
      if (c?.url) {
        return (
          <a
            key={idx}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline align-super text-[10px] font-mono-edge mx-0.5"
            title={`${c.publication || ''} — ${c.title || c.url}`}
            data-testid={`${prefix}-${n}`}
          >
            [{n}]
          </a>
        );
      }
      return (
        <sup
          key={idx}
          className="text-[10px] font-mono-edge text-muted-foreground mx-0.5"
        >
          [{n}]
        </sup>
      );
    }
    return <React.Fragment key={idx}>{tok}</React.Fragment>;
  });
}
